import styled from "styled-components";

const InteractiveWrapper = styled.div`
  cursor: pointer;
`;

export default InteractiveWrapper;
